const a = ["#29337d", "#5b8aa8", "#72b5a8", "#a5d69a", "#e8e890"], _ = [
  "#29337d",
  "#505891",
  "#5b8aa8",
  "#72b5a8",
  "#a5d69a",
  "#e8e890"
], E = [
  "#29337d",
  "#505891",
  "#5b8aa8",
  "#72b5a8",
  "#a5d69a",
  "#c5e092",
  "#e8e890"
], L = [
  "#29337d",
  "#505891",
  "#5472a0",
  "#5b8aa8",
  "#72b5a8",
  "#a5d69a",
  "#c5e092",
  "#e8e890"
], e = [
  "#29337d",
  "#505891",
  "#5472a0",
  "#5b8aa8",
  "#72b5a8",
  "#89c7a3",
  "#a5d69a",
  "#c5e092",
  "#e8e890"
], b = [
  "#29337d",
  "#505891",
  "#5472a0",
  "#5b8aa8",
  "#64a0ab",
  "#72b5a8",
  "#89c7a3",
  "#a5d69a",
  "#c5e092",
  "#e8e890"
];
export {
  b as HEAT_MAP_BLUE_YELLOW_10,
  a as HEAT_MAP_BLUE_YELLOW_5,
  _ as HEAT_MAP_BLUE_YELLOW_6,
  E as HEAT_MAP_BLUE_YELLOW_7,
  L as HEAT_MAP_BLUE_YELLOW_8,
  e as HEAT_MAP_BLUE_YELLOW_9
};
//# sourceMappingURL=index.es5570.js.map
